import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/ui-bits";
import { COMPANY } from "@/data/site";

export default function Contact() {
  return (
    <>
      <Seo title="Contact — EI Battery Solutions" description="Contact EI Battery Solutions sales for wholesale battery and hybrid inverter enquiries. Phone 0414 662 445." />
      <section className="bg-ei-navy text-ei-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <Eyebrow className="text-ei-gold">Talk to sales</Eyebrow>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight">Contact</h1>
          <p className="mt-5 text-lg text-ei-white/75 max-w-2xl leading-relaxed">
            Registered electrical contractors can reach our sales team directly, or request a wholesale quote online.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24 grid lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          <a href={COMPANY.phoneHref} className="flex items-center gap-4 bg-white border border-ei-mist rounded-md p-6 hover:border-ei-navy/30 transition-colors" data-testid="contact-phone">
            <span className="w-12 h-12 rounded-sm bg-ei-navy flex items-center justify-center flex-shrink-0"><Phone className="w-5 h-5 text-ei-gold" /></span>
            <span>
              <span className="block ei-eyebrow">Sales phone</span>
              <span className="block font-display text-xl font-bold text-ei-navy tnum mt-1">{COMPANY.phone}</span>
            </span>
          </a>
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-4 bg-white border border-ei-mist rounded-md p-6 hover:border-ei-navy/30 transition-colors" data-testid="contact-email">
            <span className="w-12 h-12 rounded-sm bg-ei-navy flex items-center justify-center flex-shrink-0"><Mail className="w-5 h-5 text-ei-gold" /></span>
            <span>
              <span className="block ei-eyebrow">Sales email</span>
              <span className="block font-display text-lg font-bold text-ei-navy mt-1 break-all">{COMPANY.email}</span>
            </span>
          </a>
          <div className="bg-white border border-ei-mist rounded-md p-6">
            <span className="block ei-eyebrow">Service area</span>
            <span className="block font-display text-lg font-semibold text-ei-navy mt-1">{COMPANY.serviceArea}</span>
            <span className="mt-4 block ei-eyebrow">Business address</span>
            <span className="block text-sm font-semibold text-ei-navy mt-1" data-testid="contact-address">{COMPANY.address}</span>
            <span className="mt-4 block ei-eyebrow">ABN</span>
            <span className="block text-sm font-semibold text-ei-navy tnum mt-1" data-testid="contact-abn">{COMPANY.abn}</span>
          </div>
        </div>

        <div className="bg-ei-navy text-ei-white rounded-md p-8 lg:p-10 flex flex-col justify-center">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Request a wholesale quote</h2>
          <p className="mt-4 text-ei-white/75 leading-relaxed">
            The fastest way to get pricing is to submit your trade details and quantities. You'll receive a reference
            immediately and a call from our team.
          </p>
          <Link to="/request-a-quote" className="mt-8 self-start font-display text-sm font-bold bg-ei-gold text-ei-navy px-6 py-3.5 rounded-sm hover:bg-[#b89747] transition-colors inline-flex items-center gap-2 min-h-[44px]" data-testid="contact-quote-cta">
            Request a quote <ArrowRight className="w-4 h-4" />
          </Link>
          <p className="mt-6 text-xs text-ei-white/60 leading-relaxed border-t border-ei-white/15 pt-4" data-testid="contact-supply-blurb">
            EI Battery Solutions supplies batteries, hybrid inverters and solar panels to Australian REC's. We are
            supply-only — contractors own the design, installation and maintenance.
          </p>
        </div>
      </section>
    </>
  );
}
